import { makeid } from 'utils/helpers/makeid';

import type { TFormItem } from '../../types';

export const maCriticalTemplate: TFormItem[] = [
  {
    key: makeid(10),
    title: <p>Chart Review: Critical Vital(s)</p>,
    description: 'Check all that apply and specify details',
    type: 'checkbox',
    required: false,
    name: 'templateType',
    options: [
      {
        label: 'Systolic blood pressure',
        value: 'systolic blood pressure',
        key: makeid(10),
      },
      {
        label: 'Diastolic blood pressure',
        value: 'diastolic blood pressure',
        key: makeid(10),
      },
      {
        label: 'Pulse',
        value: 'pulse',
        key: makeid(10),
      },
      {
        label: 'SpO2',
        value: 'SpO2',
        key: makeid(10),
      },
      {
        label: 'Blood Glucose',
        value: 'blood glucose',
        key: makeid(10),
      },
      {
        label: 'Weight',
        value: 'weight',
        key: makeid(10),
        hideSubitemsIfParentNotSelected: true,
        subItems: [
          {
            key: makeid(10),
            title: null,
            type: 'checkbox',
            required: false,
            name: 'weightOptions',
            options: [
              {
                label: 'Weight Management',
                value: 'weight management',
                key: makeid(10),
              },
              {
                label: 'Fluid management',
                value: 'fluid management',
                key: makeid(10),
              },
            ],
          },
        ],
      },
    ],
  },
  {
    key: makeid(10),
    title: <p>Patient Status & Associated Workflow</p>,
    type: 'radio',
    required: false,
    name: 'patientStatus',
    options: [
      {
        key: makeid(10),
        label: 'Do Not Call status',
        value: 'doNotCall',
        hideSubitemsIfParentNotSelected: true,
        subItems: [
          {
            key: makeid(10),
            title: null,
            type: 'checkbox',
            required: false,
            name: 'doNotCallOptions',
            options: [
              {
                label: 'Escalate per protocol',
                value: 'escalatePerProtocol',
                key: makeid(10),
              },
            ],
          },
        ],
      },
      {
        key: makeid(10),
        label: 'Hospital Hold status   ',
        value: 'hospitalHold',
        hideSubitemsIfParentNotSelected: true,
        subItems: [
          {
            key: makeid(10),
            title: null,
            type: 'radio',
            required: false,
            name: 'hospitalHoldOptions',
            options: [
              {
                label: 'Contacted Patient',
                value: 'contactedPatient',
                key: makeid(10),
                hideSubitemsIfParentNotSelected: true,
                subItems: [
                  {
                    key: makeid(10),
                    title: null,
                    type: 'checkbox',
                    required: false,
                    name: 'contactedPatientOptions',
                    options: [
                      {
                        label: 'Was reading true?',
                        value: 'wasReadingTrue',
                        key: makeid(10),
                      },
                      {
                        type: 'info',
                        value: '_info',
                        label: 'If yes, remove hospital hold obtain a re-check',
                        key: makeid(10),
                        subItems: [
                          {
                            type: 'radio',
                            name: 'removeHospitalHold',
                            title: null,
                            key: makeid(10),
                            options: [
                              {
                                label:
                                  'Patient unable to recheck – transfer to nurse',
                                value: 'patientUnableToReCheck',
                                key: makeid(10),
                              },
                              {
                                label:
                                  'Recheck is still critical or at-risk – transfer to nurse',
                                value: 'recheckIsStillCriticalOrAtRisk',
                                key: makeid(10),
                              },
                            ],
                          },
                        ],
                      },
                      {
                        type: 'info',
                        value: '_info',
                        label: 'If no, mark reading as erroneous. ',
                        key: makeid(10),
                        subItems: [
                          {
                            type: 'radio',
                            name: 'markAsErroneous',
                            title: null,
                            key: makeid(10),
                            options: [
                              {
                                label: 'Someone else used the device',
                                value: 'someoneElseUsedTheDevice',
                                key: makeid(10),
                              },
                              {
                                label: 'Weight at wrong time of day',
                                value: 'weightAtWrongTimeOfDay',
                                key: makeid(10),
                              },
                              {
                                label: 'Incorrect device technique',
                                value: 'incorrectDeviceTechnique',
                                key: makeid(10),
                              },
                              {
                                label:
                                  'Patient reports reading is in error. Erroneous reading is due to (reason). ',
                                value: 'patientReportsReadingIsInError',
                                key: makeid(10),
                                hideSubitemsIfParentNotSelected: true,
                                subItems: [
                                  {
                                    type: 'textarea',
                                    name: 'patientReportsReadingIsInErrorComment',
                                    title: null,
                                    key: makeid(10),
                                  },
                                ],
                              },
                            ],
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
              {
                key: makeid(10),
                label: 'Unable to Reach Patient',
                value: 'unableToReachPatient',
                hideSubitemsIfParentNotSelected: true,
                subItems: [
                  {
                    key: makeid(10),
                    title: (
                      <i>
                        Does protocol require escalation of unreachable
                        patients?
                      </i>
                    ),
                    type: 'radio',
                    required: false,
                    name: 'unableToReachPatientOptions',
                    options: [
                      {
                        label: 'Yes',
                        value: 'yes',
                        key: makeid(10),
                      },
                      {
                        label: 'No',
                        value: 'no',
                        key: makeid(10),
                      },
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
  {
    key: makeid(10),
    title: <p>Recovered Reading Review</p>,
    type: 'empty',
    name: '_empty',
    items: [
      {
        key: makeid(10),
        title: (
          <i>
            Critical reading has recovered (returned to within normal limits
            within 2 hours)
          </i>
        ),
        type: 'radio',
        required: false,
        name: 'hasRecovered',
        options: [
          {
            label: 'Yes',
            value: 'yes',
            key: makeid(10),
            hideSubitemsIfParentNotSelected: true,
            subItems: [
              {
                key: makeid(10),
                title: (
                  <i>
                    Does protocol require escalation of recovered readings?{' '}
                  </i>
                ),
                type: 'radio',
                required: false,
                name: 'hasRecoveredOptions',
                options: [
                  {
                    label: 'Yes',
                    value: 'yes',
                    key: makeid(10),
                  },
                  {
                    label: 'No',
                    value: 'no',
                    key: makeid(10),
                  },
                ],
              },
            ],
          },
          {
            label: 'No',
            value: 'no',
            key: makeid(10),
          },
        ],
      },
    ],
  },
  {
    key: makeid(10),
    title: <p>Escalation</p>,
    type: 'empty',
    name: '_empty',
    items: [
      {
        key: makeid(10),
        title: <i>Method of escalation (select all that apply)</i>,
        type: 'checkbox',
        required: false,
        name: 'escalationMethod',
        options: [
          {
            label: 'Phone',
            value: 'phone',
            key: makeid(10),
            hideSubitemsIfParentNotSelected: true,
            subItems: [
              {
                key: makeid(10),
                title: <i>Person spoken to (name/role)</i>,
                type: 'input',
                required: false,
                name: 'personSpokenTo',
              },
              {
                key: makeid(10),
                title: <i>Summary of call</i>,
                type: 'textarea',
                required: false,
                name: 'summaryOfCall',
              },
            ],
          },
          {
            label: 'SMS',
            value: 'sms',
            key: makeid(10),
          },
          {
            label: 'Email',
            value: 'email',
            key: makeid(10),
          },
        ],
      },
    ],
  },
];
